import client from './main-client';

export const linesApi = (params) => client().get(`/lines/?userId=${params.userId}&$limit=null&active=true`);

export const addLineApi = (data) => client().post('/lines', data);

export const updateLineApi = (data) => client().put(`/lines/${data._id}`, data);
